module.exports = __webpack_public_path__ + "static/media/jasperquak.a4a2d317.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jasperquak.webp
// module id = 501
// module chunks = 0